import IdvParallelVerificationPage from "@faire/prototype-playground/workspace/td/idv-parallel";
import { Route, Switch } from "react-router-dom";

export function TerenceDicksonRoutes() {
  return (
    <Switch>
      <Route path="/td/idv-parallel" component={IdvParallelVerificationPage} />
    </Switch>
  );
}

export const slug = "td";
